import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */
import React from 'react';
import { SurveyMarshal } from '@atlaskit/contextual-survey';
import { markAsSeenAndFatigued, sendUserResponse } from '../../services/engage-targeting';
import { getFlag, setFlag } from '../../services/have-i-seen-it';
import ContextualSurvey from '../contextual-survey/main';
export default function ContextualSurveyWithTransition(props) {
  return /*#__PURE__*/React.createElement(SurveyMarshal, {
    shouldShow: true
  }, function () {
    return /*#__PURE__*/React.createElement(ContextualSurvey, _extends({
      markAsSeenAndFatigued: markAsSeenAndFatigued,
      sendUserResponse: sendUserResponse,
      getFlag: getFlag,
      setFlag: setFlag
    }, props));
  });
}